import React from "react"

import ImageEdit from "../common/ImageEdit"

import Div from "../layouts/Div"

import Backend from "../../../utils/Backend"
import AuthManager from "../../../utils/AuthManager"
import Email from "../../../utils/Email"
import Notify from "../../../utils/Notify"

export default class AccountSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      loading: false,
      data: AuthManager.currentUser,
    }
  }

  isFormValid(){
    let {
      data
    } = this.state

    let {
      first_name,
      last_name,
      email
    } = data.user

    let isValid = true
    let error = null

    if(!first_name || first_name === ""){
      isValid = false
      error = "Please enter a valid first name"
    }
    else if(!last_name || last_name === ""){
      isValid = false
      error = "Please enter a valid last name"
    }
    else if(!Email.isValid(email)){
      isValid = false
      error = "Please enter a valid email"
    }

    if(error){
      Notify.error(error)
    }

    return isValid
  }

  _update(){
    let {
      data
    } = this.state

    if(!this.isFormValid()){
      return
    }

    this.setState({ loading: true })
    this._handleBackendCall(data)
    .then(() => {
      this.setState({
        loading: false
      })
      Notify.success("Account updated successfully!")
    })
    .catch(error => {
      this.setState({
        loading: false
      })
      Notify.error(error.message)
    })
  }

  _handleBackendCall(data){
    if(AuthManager.isPartner()){
      return Backend.updateCompanyMember(data)
    }
    return Backend.updateAdmin(data)
  }

  _handleChange(e) {
    let data = this.state.data
    data[e.target.name] = e.target.value
    this.setState({ data, error: null })
  }

  _handleChangeUser(e) {
    let data = this.state.data
    data.user[e.target.name] = e.target.value
    this.setState({ data, error: null })
  }

  render() {
    let {
      data,
      loading
    } = this.state

    return (
      <>
        <Div
          className="kt-wizard-v2__content"
          data-ktwizard-type="step-content"
          data-ktwizard-state="current"
          disabled={loading}
        >
        <div className="kt-heading kt-heading--md">Account Settings</div>
          <div className="kt-form__section kt-form__section--first">
            <div className="kt-wizard-v2__form">

              <div className="form-group row">
                <label className="col-lg-3 col-form-label">First Name</label>
                <div className="col-lg-9 my-auto">
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    name="first_name"
                    defaultValue={ data.user.first_name }
                    onChange={e => this._handleChangeUser(e)}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-lg-3 col-form-label">Last Name</label>
                <div className="col-lg-9 my-auto">
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    name="last_name"
                    defaultValue={ data.user.last_name }
                    onChange={e => this._handleChangeUser(e)}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-lg-3 col-form-label">Email</label>
                <div className="col-lg-9 my-auto">
                  <input
                    type="email"
                    className="form-control form-control-solid"
                    name="email"
                    defaultValue={ data.user.email }
                    disabled
                    onChange={e => this._handleChangeUser(e)}
                  />
                </div>
              </div>

            </div>
          </div>

        </Div>
        <div className="kt-form__actions pull-right">
          <button
            className="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
            disabled={loading}
            onClick={() => this._update()}
          >
            Save Changes
          </button>
        </div>
      </>
    )
  }
}
